import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBubbleSparkle"><Path fillRule="evenodd" clipRule="evenodd" d="M21.002 3V19.0361H15.376L11.9941 21.8379L8.65137 19.0361H3.00195V3H21.002ZM10.3486 9.59961L7.74902 10.5996V11.4004L10.3486 12.4004L11.3486 15H12.1484L13.1484 12.4004L15.749 11.4004V10.5996L13.1484 9.59961L12.1484 7H11.3486L10.3486 9.59961Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleSparkle;
